import React from 'react';
import DetailedHeader from '../../../../components/ProjectDetailedPageComponents/DetailedHeader';
import ImageSlider from '../../../../components/Misc/ImageSlider';
import projectImage1 from '../../../../assets/images/work/ontario-mine-rescue/OMR_Slider.jpg';
import projectImage2 from '../../../../assets/images/work/ontario-mine-rescue/OMR_Slider_2.jpg';
import projectImage3 from '../../../../assets/images/work/ontario-mine-rescue/OMR_Slider_3.jpg';
import projectImage4 from '../../../../assets/images/work/ontario-mine-rescue/OMR_Slider_4.jpg';
import projectImage5 from '../../../../assets/images/work/ontario-mine-rescue/OMR_Slider_5.jpg';

import Data_OntarioMineRescue from './Data_OntarioMineRescue';

function Work_OntarioMineRescue() {
    return (
        <>
            <DetailedHeader
                heading="Inside the World of Ontario Mine Rescue"
                client="Dynamic Earth, Ontario Mine Rescue"
                service="Installation / VR"
                date="2020 - Present"
            />
            <ImageSlider
                noArt="true"
                swiperNav="true"
                youtubeUrl="https://www.youtube.com/watch?v=MS6vbAbuhzk"
                images={[
                    {
                        image: projectImage1,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage2,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage3,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage4,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage5,
                        alt: 'Project Image',
                    },
                ]}
            />

            {Data_OntarioMineRescue.content}
        </>
    );
}

export default Work_OntarioMineRescue;
